import { useState, useRef } from 'react';

export default function NewsletterSection() {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState<'idle' | 'submitting' | 'success' | 'error'>('idle');
  const [message, setMessage] = useState('');
  const formRef = useRef<HTMLFormElement>(null);

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    const form = formRef.current;
    if (!form) return;

    const formData = new FormData(form);
    const honeypot = formData.get('website_alt') as string;
    if (honeypot && honeypot.trim() !== '') {
      setStatus('success');
      setMessage('订阅成功！感谢您的关注。');
      setEmail('');
      return;
    }

    setStatus('submitting');

    try {
      const payload = new URLSearchParams();
      payload.append('email', email);
      payload.append('formId', 'd9nh7gsit35ii3jdlr9g');

      const response = await fetch('https://readdy.ai/api/form/d9nh7gsit35ii3jdlr9g', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: payload.toString(),
      });

      const responseText = await response.text();
      let parsed;
      try {
        parsed = JSON.parse(responseText);
      } catch {
        parsed = null;
      }

      if (response.ok && parsed && parsed.code === 'OK') {
        setStatus('success');
        setMessage('订阅成功！感谢您的关注，我们将为您推送最新影视资讯。');
        setEmail('');
      } else {
        const serverMsg = parsed?.meta?.message || parsed?.message || parsed?.meta?.detail || responseText || '订阅失败，请稍后重试';
        setStatus('error');
        setMessage(serverMsg);
      }
    } catch {
      setStatus('error');
      setMessage('网络错误，请检查网络连接后重试。');
    }
  };

  return (
    <section className="w-full bg-primary-500 py-14 md:py-18">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-2xl mx-auto text-center">
          <div className="w-14 h-14 md:w-16 md:h-16 flex items-center justify-center mx-auto mb-5 rounded-2xl bg-white/20">
            <i className="ri-mail-send-line text-2xl text-white"></i>
          </div>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-white mb-3">
            订阅影视资讯
          </h2>
          <p className="text-white/80 text-sm md:text-base mb-8">
            第一时间获取最新电影上线、热门剧集更新通知，精彩内容不错过
          </p>

          <form
            ref={formRef}
            onSubmit={handleSubmit}
            data-readdy-form
            className="flex flex-col sm:flex-row items-center gap-3 max-w-md mx-auto"
          >
            <input
              type="email"
              name="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="输入您的邮箱地址"
              required
              className="w-full px-5 py-3 text-sm bg-white text-foreground-950 placeholder-foreground-400 rounded-full focus:outline-none focus:ring-2 focus:ring-white/50"
            />
            <input
              type="text"
              name="website_alt"
              tabIndex={-1}
              autoComplete="off"
              aria-hidden="true"
              readOnly
            />
            <button
              type="submit"
              disabled={status === 'submitting'}
              className="w-full sm:w-auto px-8 py-3 bg-foreground-950 hover:bg-foreground-900 text-white font-medium rounded-full transition-all cursor-pointer whitespace-nowrap disabled:opacity-60 disabled:cursor-not-allowed"
            >
              {status === 'submitting' ? '提交中...' : '立即订阅'}
            </button>
          </form>

          {status === 'success' && (
            <p className="mt-4 text-white/90 text-sm">{message}</p>
          )}
          {status === 'error' && (
            <p className="mt-4 text-yellow-200 text-sm">{message}</p>
          )}

          <p className="mt-4 text-white/50 text-xs">
            尊重您的隐私，随时可取消订阅
          </p>
        </div>
      </div>
    </section>
  );
}